export const proxy = (url: string): string => url;
